import axios from "axios";

const API_URL: string = process.env.REACT_APP_API_URL as string

const instance = axios.create({
    baseURL: API_URL
});

const persistKey = "persist:v100-demo1-auth"

export const API = ()=>{

    if(localStorage.getItem(persistKey)){
        let persistData:string = localStorage.getItem(persistKey) as string
        let persist = JSON.parse(persistData)
        if(persist.accessToken){
            let accessToken = JSON.parse(persist.accessToken)
            instance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        }
    }

    return instance
}